module.exports = __webpack_public_path__ + "img/mb_img_company_01_en.59e48ece.jpg";